/* eslint-disable */
import axios from 'axios'
import config from '@assets/config.json'; // api 请求json  
import store from '../store/store'

//service.js
import Router from 'vue-router';  

const myService = function (Vue, options) {
  Vue.prototype.$service = { 
    getProduct(that,opt) { // 获取产品排行榜([{Topic说明\":\"-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"}] )
    // apply 0:全部 ; 1免费体验； -1不能体验
    //canApply 0体验已经过期 ；1没过期；
        return new Promise((resolve, reject) => {
            that.$http.post(`${config.api.reqApi}/api/product/GetByExhibition?topic=${opt.topic}&apply=${opt.apply}`, opt.body, store.getters.getHeaders).then((res) => { 
                if (res.status === 200) {
                    let arr = [];
                    if (that.proList && that.proList.length > 0) {
                        arr = that.proList;
                    }

                    res.data.items.map((c,index)=>{
                        if (c.banner.search(/^\[/) !== -1) {
                            c.banner = JSON.parse(c.banner);
                        } else {
                            c.banner = [c.banner];
                        }
                        
                        if (c.category) {
                            c.category = JSON.parse(c.category);
                        }

                        if(opt.apply == 1) {
                            if (c.applyEnd) {
                                c.applyEnd = this.fixDate(c.applyEnd);
                            }
                            if (c.applyEnd) {
                                c.applyEnd = this.restTime(c.applyEnd);
                            }
                            if (c.applyStart) {
                                c.applyStart = this.isStart(c.applyStart);
                            }
                        }
                    })
                    that.proList = res.data.items;
                    if (arr && arr.length>0) {
                        that.proList = [...arr,...that.proList]; 
                    }
                    that.Total = res.data.totalCount
                    if(that.proList.length >= res.data.totalCount){ 
                        console.log('产品所有数据请求完成',res.data.totalCount)
                        that.donetTip = true;
                        resolve(that.proList);
                        return;
                    }   
                    console.log('单次数据请求产品',that.proList,that.ToTal)
                    resolve(that.proList);
                }
            }).catch(err => { reject(err)});
        });
    },
    getExChanceAllList(that,opt){ // 获取展会全部商机(新)；
        return new Promise((resolve, reject) => {
            that.$http.post(`${config.api.reqApi}/api/release/GetByExhibition`, opt, store.getters.getHeaders).then((res) => {
                if(res.status === 200){
                    let arr = [];
                    if (that.chanceList && that.chanceList.length > 0) {
                        arr = that.chanceList;
                    }
                    res.data.items.map(c=>{
                        if (c.photo.search(/^\[/) !== -1) {
                            c.photo = JSON.parse(c.photo);
                        } else {
                            c.photo = [c.photo];
                        }
                        // c.inTime = this.SmarDate(new Date(c.inTime));
                        // c.uvList.items.map(b=>{
                        //     b.userInfo = JSON.parse(b.userInfo);
                        // })
                    })
                    that.chanceList = res.data.items;
                    that.totalCount = res.data.totalCount;
                    if (arr && arr.length>0) {
                        that.chanceList = [...arr,...that.chanceList];
                    } 
                    if(that.chanceList.length >= res.data.totalCount){
                        console.log('商机所有数据请求完成',res.data.totalCount)
                        that.donetTip = true;
                        resolve(that.chanceList);
                        return;
                    }
                    console.log('商机单次数据请求完',res.data.pageIndex)
                    resolve(that.chanceList);
                }
            }).catch(err => reject(err));
        });
    },
    getExAllPro(that,opt,url){ // 获取展商活动 Topic说明":"-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐
        return new Promise((resolve, reject) => {
            that.$http.post(url, opt, store.getters.getHeaders).then((res) => {
                if(res.status === 200){
                    let arr = [];
                    if (that.proList && that.proList.length > 0) {
                        arr = that.proList;
                    }
                    res.data.items.map(c=>{
                        if (c.banner.search(/^\[/) !== -1) {
                            c.banner = JSON.parse(c.banner);
                        } else {
                            c.banner = [c.banner];
                        }
                        if (c.category) {
                            c.category = JSON.parse(c.category);
                        }
                        if (c.tag) {
                            c.tag = JSON.parse(c.tag);
                        }
                    })
                    that.proList = res.data.items;
                    if (arr && arr.length>0) {
                        that.proList = [...arr,...that.proList];
                    } 
                    if(that.proList.length >= res.data.totalCount){
                        console.log('活动所有数据请求完成',res.data.totalCount)
                        that.donetTip = true;
                        resolve(that.proList);
                        return;
                    }
                    console.log('活动单次数据请求完',res.data.pageIndex)
                    console.log(that.proList)
                    resolve(that.proList);
                }
            }).catch(err => reject(err));
        });
    },
    getActList(that,opt,topic) { // 获取活动列表 ([{Topic说明\":\"-4：免费报名，-3：新发布，-2：热搜，-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"}] )
        return new Promise((resolve, reject) => {
            that.$http.post(`/api/activity/GetByExhibition?topic=${topic}`, opt, store.getters.getHeaders).then((res) => {
                if(res.status === 200){
                    let arr = [];
                    if (that.ActData && that.ActData.length > 0) {
                        arr = that.ActData;
                    }
                    res.data.items.map(c=>{
                        if (c.banner.search(/^\[/) !== -1) {
                            c.banner = JSON.parse(c.banner);
                        } else {
                            c.banner = [c.banner];
                        }
                        // c.startTime = that.$moment(c.startTime, "MM月DD日 HH:mm");
                        // c.endTime = this.pastActivity(c.endTime);
                    })
                    that.ActData = res.data.items;
                    that.totalCount = res.data.totalCount;
                    if (arr && arr.length>0) {
                        that.ActData = [...arr,...that.ActData];
                    } 
                    if(that.ActData.length >= res.data.totalCount){
                        console.log('活动所有数据请求完成',res.data.totalCount)
                        that.donetTip = true;
                        resolve(that.ActData);
                        return;
                    } 
                    resolve(that.ActData);
                }
            }).catch(err => {reject(err)});
        });
    },

    getProductLive (that, opt,topic,tagId) { // 获取展品排行榜([{Topic说明\":\"-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"}] )
        // apply 0:全部 ; 1免费体验； -1不能体验
        //canApply 0体验已经过期 ；1没过期；
        return new Promise((resolve, reject) => {
            that.$http.post(`/api/product/GetByExhibitionLive?topic=${topic}&apply=0&tagId=${tagId}`, opt).then((res) => {
                // debugger
                if (res.status === 200) {
                    let arr = [];
                    if (that.ActData && that.ActData.length > 0) {
                        arr = that.ActData;
                    }

                    res.data.items.map((c, index) => {
                        if (c.banner.search(/^\[/) !== -1) {
                            c.banner = JSON.parse(c.banner);
                        } else {
                            c.banner = [c.banner];
                        }

                        if (c.category) {
                            c.category = JSON.parse(c.category);
                        }

                        if (opt.apply == 1) {
                            if (c.applyEnd) {
                                c.applyEnd = this.fixDate(c.applyEnd);
                            }
                            if (c.applyEnd) {
                                c.applyEnd = this.restTime(c.applyEnd);
                            }
                            if (c.applyStart) {
                                c.applyStart = this.isStart(c.applyStart);
                            }
                        }
                    })
                    that.ActData = res.data.items;
                    if (arr && arr.length > 0) {
                        that.ActData = [...arr, ...that.ActData];
                    }
                    if (that.ActData.length >= res.data.totalCount) {
                        that.donetTip = true;
                        resolve(that.ActData);
                        return;
                    }
                    console.log('单次数据请求展品', that.ActData)
                    resolve(that.ActData);
                }
            }).catch(err => { wx.hideLoading(); reject(err) });
        });
    },

    getCategoryByGroupId(that,opt,topic) { 
        return new Promise((resolve, reject) => {
            that.$http.get(`/api/Category/ByGroupId?level=-1`, opt, store.getters.getHeaders).then((res) => {
                if(res.status === 200){
                  
                    resolve(res.data);
                }
            }).catch(err => {reject(err)});
        });
    },

    postTagCount (that, opt) { 
        return new Promise((resolve, reject) => {
            that.$http.post(`/api/ProductTagCount`, opt , store.getters.getHeaders).then((res) => {
                    resolve(that);
            }).catch(err => { wx.hideLoading(); reject(err) });
        });
    },








    getActDetails(that,id){ // 获取活动详情；
      return new Promise((resolve, reject) => {
          that.$http.get(`/api/activity?id=${id}`, store.getters.getHeaders).then((res) => {
              if(res.status === 200){ 
                  var list = res.data;
                  if(list.banner.search(/^\[/) !== -1){
                      list.banner = JSON.parse(list.banner);
                  } else {
                      list.banner = [list.banner];
                  }
                  list.video = JSON.parse(list.video);
                  resolve(list);
              }
          }).catch(err => reject(err));
      });
    },
    getCompanyInfo(that,id){ // 获取公司信息
      return new Promise((resolve, reject) => {
          that.$http.get(`/api/company?id=${id}`, store.getters.getHeaders).then((res) => {
              if(res.status === 200 && res.data){
                  let data = res.data;
                  data.category = JSON.parse(data.category);
                  data.properties = JSON.parse(data.properties) 
                  resolve(data);
              }
          }).catch(err => reject(err));
      });
    },
    showDialog(that, msg, bool) { // 封装 对话框两种常用状态  成功和失败
      that.$dialog.toast({ mes: msg, timeout: 1500, icon: bool ? 'success' : 'error' });
    },
    /**
     * 计算开始的时间在当前时间的描述  4分钟前 1小时前 ...
     * @param {Date} originDate 开始时间
     * @return {string} 该时间在当前时间的描述
     */
    SmarDate(originDate) {
      let nowDate = new Date(),
        isToday = false,
        isYesterday = false,
        isPastYear = false,
        isPreviousYear = false,
        originYear,
        originMonth,
        originDay,
        diffMinute,
        formatedDate;

      diffMinute = Math.round((nowDate.getTime() - originDate.getTime()) / (1000 * 60));

      originYear = originDate.getFullYear();
      originMonth = originDate.getMonth() + 1;
      originDay = originDate.getDate();

      if (diffMinute <= nowDate.getHours() * 60) {
        isToday = true;
      }
      if (nowDate.getDate() - originDay == 1) {
        isYesterday = true;
      }
      if (nowDate.getFullYear() - originYear == 1) {
        isPreviousYear = true;
      } else if (nowDate.getFullYear() - originYear > 1) {
        isPastYear = true;
      }
      if (diffMinute < 10 && isToday) {
        formatedDate = '刚刚';
      } else if (diffMinute < 60 && isToday) {
        formatedDate = `${diffMinute}分钟前`;
      } else if (diffMinute < 60 * 24 && isToday) {
        formatedDate = `${Math.floor(diffMinute / 60)}小时前`;
      } else if (diffMinute < 60 * 24 * 2 && isYesterday) {
        formatedDate = '1天前';
      } else if (diffMinute < 60 * 24 * 4) {
        formatedDate = '2天前';
      } else if (isPreviousYear) {
        formatedDate = '去年';
      } else if (isPastYear) {
        formatedDate = `${originYear}年`;
      } else {
        formatedDate = `${originMonth}月${originDay}日`;
      }
      return formatedDate;
    },
    SmarDateEn(originDate) {
        let nowDate = new Date(),
          isToday = false,
          isYesterday = false,
          isPastYear = false,
          isPreviousYear = false,
          originYear,
          originMonth,
          originDay,
          diffMinute,
          formatedDate;
  
        diffMinute = Math.round((nowDate.getTime() - originDate.getTime()) / (1000 * 60));
  
        originYear = originDate.getFullYear();
        originMonth = originDate.getMonth() + 1;
        originDay = originDate.getDate();
  
        if (diffMinute <= nowDate.getHours() * 60) {
          isToday = true;
        }
        if (nowDate.getDate() - originDay == 1) {
          isYesterday = true;
        }
        if (nowDate.getFullYear() - originYear == 1) {
          isPreviousYear = true;
        } else if (nowDate.getFullYear() - originYear > 1) {
          isPastYear = true;
        }
        if (diffMinute < 10 && isToday) {
          formatedDate = 'just now';
        } else if (diffMinute < 60 && isToday) {
          formatedDate = `${diffMinute}mins ago`;
        } else if (diffMinute < 60 * 24 && isToday) {
          formatedDate = `${Math.floor(diffMinute / 60)}hrs ago`;
        } else if (diffMinute < 60 * 24 * 2 && isYesterday) {
          formatedDate = '1 day ago';
        } else if (diffMinute < 60 * 24 * 4) {
          formatedDate = '2 days ago';
        } else if (isPreviousYear) {
          formatedDate = 'last year';
        } else if (isPastYear) {
          formatedDate = `${originYear} year`;
        } else {
          switch(originMonth) {
            case 1: 
              originMonth = "January";
              break;
            case 2: 
              originMonth = "February";
              break;
            case 3: 
              originMonth = "march";
              break;
            case 4:
              originMonth = "April";
              break;
            case 5:
              originMonth = "May";
              break;
            case 6: 
              originMonth = "June";
              break;
            case 7: 
              originMonth = "July";
              break;
            case 8: 
              originMonth = "August";
              break;
            case 9: 
              originMonth = "September";
              break;
            case 10: 
              originMonth = "October";
              break;
            case 11: 
              originMonth = "November";
              break;
            case 12: 
              originMonth = "December";
              break;
          }
          formatedDate = `${originMonth} ${originDay}`;
        }
        return formatedDate;
      },
    replaceSpeace(txt) {
      if (!txt)return;
      let txt1 = txt.replace(/\n/g,"<br/>");
      return txt1;
    },
  }
};

export default myService;